import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'

import { DomainContext } from '../../domain-repository/DomainRepository'
import withLang from '../../withLang'

import DriverInfoHeader from '../../components/PageHeader'
import { FooterWithPrice } from '../../components/Footer'

import tollServicePTVideo from './videos/toll-service-pt.mp4'
import tollServiceENVideo from './videos/toll-service-en.mp4'
import { setPageId } from '../../services/Metrics'
import { DynamicContent } from '../../utils/dynamic-page'

const EXTRAS_MEDIA_SRC = {
  TOLLS: { default: tollServicePTVideo, pt: tollServicePTVideo, en: tollServiceENVideo },
};

function SingleExtraPage({ history, match }) {
  const { t } = useTranslation()

  const {
    getQuantityOfExtra,
    rentalAgreementQuoteValue,
    addExtra,
    removeExtra,
    getCorporateExtras,
    appFlowConfigs,
    reservation,
    isCorporate,
    getComfortExtras,
    flowNextRoute,
    language,
    localizationAssets,
    flowPreviousRoute,
    pages
  } = useContext(DomainContext)

  const [seeMoreOpen, setSeeMoreOpen] = useState(false)

  const [currentPage, setCurrentPage] = useState(null)

  const [currentExtra, setExtra] = useState(null)

  const extraId = currentExtra ? currentExtra.extraID : ''
  const hasExtra = currentExtra ? getQuantityOfExtra(currentExtra) > 0 : false

  const mediaSrc = currentExtra ? localizationAssets[`mobile${currentExtra.extraID}Video`] : null
  const isVideo = mediaSrc ? mediaSrc.endsWith('.mp4') : null

  useEffect(() => {
    if (pages) {
      const _currentPage = pages.find(p => p.url === '/single-extra/TOLLS')
      setPageId({ pageId: _currentPage.id })
      setCurrentPage(_currentPage)
    }
  }, [pages])

  useEffect(() => {
    if (currentPage && !currentExtra) {
      const extraId = currentPage.extraId
      const extra = getCorporateExtras([extraId])[0]
      if (!extra) {
        history.push(getNextStepUrl())
      } else {
        setExtra(extra)
      }
    }
  }, [currentPage, getCorporateExtras, history])

  const getNextStepUrl = useCallback(() => {
    return flowNextRoute(match.path);
  }, [match, flowNextRoute])

  const handleContentClick = useCallback((e) => {
    if (e.target.id === '_ADD-EXTRA_') {
      if (hasExtra) {
        removeExtra(currentExtra)
      } else {
        addExtra(currentExtra)
      }
    }
  }, [hasExtra, removeExtra, addExtra, currentExtra])

  return currentExtra ? (
    <div>
      <DriverInfoHeader
        title={t('comfort')}
        active={2}
        progress={'69.5%'}
        handleLogoClick={() => history.push('/start')}
      />
      <main>
        <div className="container container-large">
          <div className="main">
            <div className="row">
              <div className="col-md-6  d-flex align-items-center">
                <div className="w-100">
                  {currentPage ?
                    <DynamicContent onClick={handleContentClick} content={currentPage.htmlContent} />
                    : null}
                  <div className="text-left mt-4 mb-2">
                    <h2 className="title text-left color-grey">{t(`${extraId}Name`)}</h2>
                    <b>{t(`${extraId}SubTitle`)}</b>
                    <div style={seeMoreOpen ? { display: 'block' } : { display: 'none' }}>
                      <p className='mt-3'>{t(`${extraId}Description`)}</p>
                    </div>
                    <div>
                      <a onClick={() => setSeeMoreOpen((v) => !v)} className="color-green text-decoration-underline toggle" id="ver-mais">{seeMoreOpen ? t('seeLess') : t('seeMore')}</a>
                    </div>
                  </div>
                  <div className="row justify-content-end mb-4">
                    <div className="block-value col d-flex align-items-center">
                      <span>€{currentExtra.pricePerDay || currentExtra.totalPrice}/{currentExtra.pricePerDay ? t('day') : t('totalLC')}</span>
                      {hasExtra ?
                        <button onClick={() => removeExtra(currentExtra)} className="btn-check" /> :
                        <button onClick={() => addExtra(currentExtra)} className="btn-add" />
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <div className="text-center">
                  <video loop muted autoPlay className='single-extra__video' src={mediaSrc}></video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterWithPrice
          totalPrice={rentalAgreementQuoteValue}
          totalPriceLabel={t('total')}
          handleNextClick={() => history.push(getNextStepUrl())}
          handlePrevClick={() => flowPreviousRoute(history)}
          nextHighlighted={true}
        />
      </main>
    </div>
  ) : null
}

export default withLang(SingleExtraPage)
